import { SET_ROUTE } from 'actions';

export const setRoute = (route) => ({
  type: SET_ROUTE,
  payload: route,
});

export default setRoute;
